// extracted by mini-css-extract-plugin
export default {"column":"RsfNGt9W6T3EyxatDKEq","bounce":"F6ufvA0mS0ec9gAPuqGg"};